import React from "react";
import { Input } from "components/bootstrap";
const ARN = ({
  awsARN = {
    value: ""
  },
  awsExternalId = {
    value: ""
  },
  onChange
}) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
  Input,
  {
    id: "awsAssumeRoleARN",
    type: "text",
    value: awsARN.value,
    onChange,
    label: "AWS Assume Role (ARN)",
    help: "Amazon Resource Name with required cross account permission",
    placeholder: "arn:aws:sts::123456789012:assumed-role/some-role",
    maxLength: 2048
  }
), /* @__PURE__ */ React.createElement(
  Input,
  {
    id: "awsExternalId",
    type: "text",
    name: "awsExternalId",
    value: awsExternalId.value,
    onChange,
    label: "AWS External ID (optional)",
    help: "An external ID added to the AssumeRole request to prevent the confused deputy problem. Required only if your role trust policy enforces it."
  }
));
export default ARN;
